import axios from "@/helpers/axios";

export default {
  namespaced: true,
  state: {
    userInfo: {
      phoneNumber: "",
      authToken: "",
      userId: "",
    },
    idList: [],
  },
  mutations: {
    updateUserInfo(state, payload) {
      state.userInfo = payload;
    },
    updateIdList(state, payload) {
      state.idList = payload;
    },
  },
  actions: {
    //아이디 찾기 인증번호 요청
    async requestIdAuthCode({ commit }, payload) {
      try {
        const result = await axios({
          method: "post",
          url: "authenticator/request/userid/auth_code",
          data: payload,
          headers: {
            bypass: true,
          },
        });

        commit("updateUserInfo", {
          phoneNumber: payload.phoneNumber,
          authToken: result.data.token,
          userId: "",
        });

        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    //비밀번호 찾기 인증번호 요청
    async requestPwAuthCode({ commit }, payload) {
      try {
        const result = await axios({
          method: "post",
          url: "authenticator/request/password/auth_code",
          data: payload,
          headers: {
            bypass: true,
          },
        });

        commit("updateUserInfo", {
          userId: payload.userId,
          phoneNumber: payload.phoneNumber,
          authToken: result.data.token,
        });

        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    //인증번호 확인
    async verifyAuthCode({ state }, payload) {
      try {
        const result = await axios({
          method: "post",
          url: "authenticator/authenticator/verify/auth_code",
          data: { ...payload, token: state.userInfo.authToken },
          headers: {
            bypass: true,
          },
        });

        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    initializationUserInfo({ commit }) {
      commit("updateUserInfo", {
        phoneNumber: "",
        authToken: "",
        userId: "",
      });
    },
    deleteUserIdList({ commit }) {
      commit("updateIdList", []);
    },
    async findUserIdList({ commit, state }) {
      try {
        const payload = {
          phoneNumber: state.userInfo.phoneNumber,
          token: state.userInfo.authToken,
        };
        const result = await axios({
          method: "post",
          url: "/users/biz/find/user-id",
          data: payload,
          headers: {
            bypass: true,
          },
        });

        commit("updateIdList", result.data.ids);
        return result.data;
      } catch (error) {
        console.error(error);
      }
    },
    async updateUserPw({ state }, payload) {
      try {
        const updatePwPayload = {
          userId: state.userInfo.userId,
          phoneNumber: state.userInfo.phoneNumber,
          token: state.userInfo.authToken,
          password: payload.password,
          confirmPassword: payload.confirmPassword,
        };
        const result = await axios({
          method: "patch",
          url: "/users/biz/password",
          data: updatePwPayload,
          headers: {
            bypass: true,
          },
        });

        return result.data;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
